export const SELECTOR = {
    SELECT_TYPE: {
        ASSET: "AssetStore",
        RESOURCE: "ResourceCentre",
        ASSET_AND_RESOURCE: "AssetStoreAndResourceCentre",
        STANDARDS: "Standards",
        MAIN: "MainStore"
    }
};
